import DriverManagementDashboard from '../../../../templates/js/components/Cards/DriverManagementDashboard.vue'

const systemModuleSetup = app => {
  app.component('driver-management-dashboard', DriverManagementDashboard)
}

export { systemModuleSetup }
